import { init as initAnalytics } from './analytics.js';

navigator.serviceWorker.register(
  new URL('./sw.js', import.meta.url)
);

initAnalytics();
